export const scopeEntityTypeOptions = [
  { text: 'properties', value: 'properties' },
  { text: 'connectors', value: 'connectors' },
  { text: 'devices', value: 'devices' },
];

export const scopeTriggerOptions = [
  { text: 'property-create', value: 'property-create' },
  { text: 'property-update', value: 'property-update' },
  { text: 'property-delete', value: 'property-delete' },
  { text: 'connector-create', value: 'connector-create' },
  { text: 'connector-update', value: 'connector-update' },
  { text: 'connector-delete', value: 'connector-delete' },
  { text: 'device-create', value: 'device-create' },
  { text: 'device-update', value: 'device-update' },
  { text: 'device-delete', value: 'device-delete' },
];

export function normalizeScopeFilters(scopeFilters: any): any[] {
  if (Array.isArray(scopeFilters)) return scopeFilters;
  if (scopeFilters && typeof scopeFilters === 'object') return [scopeFilters];
  return [];
}

export function hasInvalidRegexPair(scopeFilters: any): boolean {
  const scopeGroups = normalizeScopeFilters(scopeFilters);

  return scopeGroups.some((scopeGroup: any) => {
    const regexAttribute = (
      scopeGroup?.regex?.attribute ??
      scopeGroup?.regex?.ruleRegexAttribute ??
      ''
    ).trim();

    const regexPattern = (
      scopeGroup?.regex?.regex ??
      scopeGroup?.regex?.ruleRegexPattern ??
      ''
    ).trim();

    const attributeIsFilled = regexAttribute.length > 0;
    const patternIsFilled = regexPattern.length > 0;

    return (
      (attributeIsFilled && !patternIsFilled) ||
      (!attributeIsFilled && patternIsFilled)
    );
  });
}
